import { AxiosResponse } from "axios"
import { HallOfFameHistoricalData } from '../models/HallOfFameHistoricalData'
import { PlayerRace } from "../models/PlayerRace"
import { PlayersInSearchData } from "../pages/main/searchRace/SearchRace"
import { api, BASE_URL } from "./api"
import { createAuthenticatedEventSource } from "./authenticatedEventSource"

interface PlayersReadyResponse {
    readyPlayers: number
    totalPlayers: number
}

export default class RaceService {

    static async addPlayerToSearchUnRankedRace(vehicleId: number): Promise<AxiosResponse<void>> {
        return api.post<void>('/race/unranked/race/search/add', { vehicleId })
    }

    static async addPlayerToSearchRankedRace(vehicleId: number): Promise<AxiosResponse<void>> {
        return api.post<void>('/race/ranked/race/search/add', { vehicleId })
    }

    static async removePlayerFromRaceSearch(): Promise<AxiosResponse<void>> {
        return api.post<void>('/race/search/remove', {})
    }

    static async acceptGhostOffer(): Promise<AxiosResponse<void>> {
        return api.post<void>('/race/search/ghost-offer/accept', {})
    }

    static async cancelGhostOffer(): Promise<AxiosResponse<void>> {
        return api.post<void>('/race/search/ghost-offer/cancel', {})
    }

    static async getUsersInSearch(): Promise<PlayersInSearchData> {
        const response = await api.get(`/race/playersInSearch`)
        return response.data as PlayersInSearchData
    }

    static async getIsPlayerInSearch(): Promise<boolean> {
        const response = await api.get(`/race/player/inSearch`)
        return response.data as boolean
    }

    static async sendContinue(): Promise<void> {
        await api.post(`/race/finish/continue`, {})
    }

    static async leaveRace(): Promise<void> {
        await api.post(`/race/leave`, {})
    }

    static async getPlayerRaceDataById(id: string): Promise<PlayerRace> {
        const response = await api.get(`/race/finish/data?raceId=${id}`)
        return response.data as PlayerRace
    }

    static async getHistoricalFinishById(id: string): Promise<HallOfFameHistoricalData> {
        const response = await api.get(`/finish/dataById?finishId=${id}`)
        console.log(response.data)
        return response.data as HallOfFameHistoricalData
    }

    static async getHistoricalFinishByActivityId(id: string): Promise<HallOfFameHistoricalData> {
        const response = await api.get(`/finish/dataByUser?activityId=${id}`)
        console.log(response.data)
        return response.data as HallOfFameHistoricalData
    }

    static async getRaceType(): Promise<string> {
        const response = await api.get(`/race/type`)
        return response.data as string
    }

    static getRacePreparationSSE(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/race/preparation/stream?token=${token}`)
    }

    static getRaceDataSSE(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/race/data/stream?token=${token}`)
    }

    static async ready(): Promise<PlayersReadyResponse> {
        const response = await api.post<PlayersReadyResponse>(`/race/ready`, {})
        return response.data
    }

    static getRaceDataSse(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/race/data/stream?token=${token}`)
    }

    static getRaceSearchDataSse(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/race/search/stream?token=${token}`)
    }

} 